import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {App} from './app/app';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://2eab2b8b145b00b57dba3c2f8b2feb8e@o4508198755500032.ingest.de.sentry.io/4510062072889424",
  sendDefaultPii: true
});
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
